import { MODEL_PORTFOLIO, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const ADDEPAR = 'addepar';
export const BLACK_DIAMOND = 'black_diamond';
export const ORION = 'orion';
export const REDTAIL = 'redtail';
export const SCHWAB = 'schwab';
export const PERSHING = 'pershing';
export const VRGL = 'vrgl';
export const BROADRIDGE = 'broadridge';
export const RAYMOND_JAMES = 'raymond_james';
// Search Modal Types
export const ADDEPAR_GROUP = 'group';
export const ADDEPAR_PORTFOLIO = 'portfolio';
export const ADDEPAR_CLIENT = 'client';
export const ADDEPAR_FUND = 'fund';
export const ADDEPAR_LEGAL_ENTITY = 'legal_entity';
export const ADDEPAR_ACCOUNT = 'account';
export const BD_SEARCH_ACCOUNT = 'account';
export const BD_SEARCH_PORTFOLIO = 'portfolio';
export const BROADRIDGE_GROUP = 'group';
export const BROADRIDGE_ACCOUNT = 'account';
export const IREBAL_MODEL = 'irebalModel';
export const IREBAL_BLENDED_MODEL = 'irebalBlendedModel';
export const IREBAL_PORTFOLIO = 'irebalPortfolio';
export const ORION_CLIENT = 'client';
export const ORION_ACCOUNT = 'account';
export const ORION_MODEL = 'model';
export const ORION_MODEL_AGGREGATE = 'modelAggregate';
export const ORION_PORTFOLIO_GROUP = 'portfolioGroup';
export const PERSHING_CLIENT = 'client';
export const PERSHING_ACCOUNT = 'account';
export const REDTAIL_CONTACT = 'contact';
export const REDTAIL_ACCOUNT = 'account';
export const SCHWAB_CLIENT = 'client';
export const SCHWAB_ACCOUNT = 'account';
export const VRGL_HOUSEHOLD = 'household';
export const VRGL_ACCOUNT = 'account';
export const VRGL_BENCHMARK = 'benchmark';
export const VRGL_INVESTMENT_STRATEGY = 'investmentStrategy';
export const VRGL_PROPOSAL_ACCOUNT = 'proposalAccount';
// Import Error Codes
export const MISSING_IDS = 'integration_missing_ids';
export const AUTH_FAILED = 'integration_authentication_failed';
export const NO_HOLDINGS = 'integration_no_holdings';
export const INVALID_RESPONSE = 'integration_invalid_response';
export const INVALID_CUSTOM_SECURITY = 'custom_security_error';
export const INVALID_CUSTOM_SECURITY_LEVELS = 'custom_security_levels_error';
export const REFRESH_INVALID_API_LEVELS = 'refresh_invalid_api_levels';
export const REFRESH_INVALID_ENTITY_ID = 'invalid_entity_id';
export const ERROR_CODE_MAP = {
    MISSING_IDS: 'Please select an item(s) before importing.',
    AUTH_FAILED: 'Check that the Integration is active.',
    TOO_MANY_RESULTS: 'The are more than 100 records available for the given search criteria. Please refine your search',
    NO_HOLDINGS: 'The selected item(s) do not have any holdings.',
    INVALID_RESPONSE: 'Something went wrong, please try again or contact support.',
    REMOVED_ACCOUNTS: 'These accounts no longer exist.',
    EXPIRED_OTP: 'Your session has timed out.  Please enter a new One Time Password from your Security Token.',
    INVALID_CUSTOM_SECURITY: 'There is an error with one of the Custom Security attributes.',
    INVALID_CUSTOM_SECURITY_LEVELS: 'There is an error with one of the Custom Security levels.',
    REFRESH_INVALID_API_LEVELS: 'There is a problem with the security levels fetched from the integration provider. Please contact support.',
    REFRESH_INVALID_ENTITY_ID: 'The selected security does not have the information required to perform the refresh. Please contact support.',
};
// Import Types
export const IMPORT_TYPE_ACCOUNT = 'account';
export const IMPORT_TYPE_HOLDINGS = 'holdings';
// Refresh custom security status
export const REFRESH_CUSTOM_SECURITY_SAME_LEVELS = 'same_levels';
export const REFRESH_CUSTOM_SECURITY_CALCULATING = 'calculating';
// Model Portfolio types
export const PORTFOLIO_TYPE_OPTIONS_CONFIG = {
    list: [
        { value: MODEL_PORTFOLIO, label: 'Model Portfolio' },
        { value: BENCHMARK_PORTFOLIO, label: 'Benchmark Portfolio' },
        { value: CLIENT_PORTFOLIO, label: 'Client Portfolio' },
    ],
};
